import { jsx as _jsx } from "react/jsx-runtime";
/* Generated file. Do not modify. */
import { createElement } from 'react';
import { IconSvg } from '../../icons/IconSvg.js';
export const ArrowUpIcon = (props) => createElement(IconSvg, {
    ...props,
    viewBox: "0 0 24 24"
}, _jsx("path", { d: "M19.4697 12.5303L12.7501 5.81065L12.7501 20H11.2501L11.2501 5.81065L4.53039 12.5303L3.46973 11.4697L12.0001 2.93933L20.5304 11.4697L19.4697 12.5303Z", fill: "currentColor" }));
//# sourceMappingURL=ArrowUpIcon.js.map